import { api } from '../../common/services/api'
import { apiError } from './api'
import { getPlainTextFromMarkup } from '../../common/models/styling'
import { getDuplicateFormPayload, getTranslatedProperty } from '../../common/models/formsV2'
import {
  API_ERRORS,
  NOT_UNIQUE_FORM_ALIAS,
  OBJECT_NOT_FOUND,
} from '../../common/constants/errors'


export const deleteFormAlias = (formId) => {
  return async dispatch => {
    try {
      dispatch({ type: 'SET_ALIAS_LOADING', data: true })
      await api.delete(`/form_v2s/${formId}/alias`)
      dispatch({ type: 'SET_FORM_V2_ALIAS', data: {
        formId,
        formAlias: '',
      }})
    } catch {
      dispatch({ type: 'SET_API_ERROR', data: {
        alias: {
          errorName: API_ERRORS.ALIAS.ALIAS_ERROR
        }
      }})
    } finally {
      dispatch({ type: 'SET_ALIAS_LOADING', data: false })
    }
  }
}

export const deleteForm = (formId, toastMessages) => {
  const { errorMessage, successMessage } = toastMessages

  return async (dispatch) => {
    try {
      dispatch({ type: 'SET_FORMS_V2_LOADING', data: true })
      await api.delete(`/form_v2s/${formId}`)
      dispatch({ type: 'SHOW_TOAST', data: {
        type: 'success',
        title: successMessage
      }})
    } catch (error) {
      dispatch({ type: 'SHOW_TOAST', data: {
        type: 'error',
        title: errorMessage
      }})
    }
    finally {
      dispatch(fetchForms())
    }
  }
}

export const fetchAlias = (formId) => {
  return async dispatch => {
    try {
      dispatch({ type: 'SET_API_ERROR', data: { alias: null }})
      dispatch({ type: 'SET_ALIAS_LOADING', data: true })
      const { data: formAlias } = await api.get(`/form_v2s/${formId}/alias`)
      dispatch({ type: 'SET_FORM_V2_ALIAS', data: {
        formId,
        formAlias: formAlias?.alias || '',
      }})
    } catch (error) {
      if (error?.response?.data?.errors[0].issue_code === OBJECT_NOT_FOUND) {
        dispatch({ type: 'SET_FORM_V2_ALIAS', data: {
          formId,
          formAlias: '',
        }})
      } else {
        dispatch({ type: 'SET_API_ERROR', data: {
          alias: {
            errorName: API_ERRORS.ALIAS.ALIAS_ERROR
          }
        }})
      }
    } finally {
      dispatch({ type: 'SET_ALIAS_LOADING', data: false })
    }
  }
}

export const fetchForms = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: 'SET_FORMS_V2_LOADING', data: true })
      const { data } = await api.get('/form_v2s')
      dispatch({ type: 'SET_FORMS_V2', data: data?.formV2s })
      const formIds = data?.formV2s.map(form => form.id)

      if (formIds.length > 0) {
        const { data: states } = await api.post('/form_v2s/requests/get-states', { form_v2_ids: formIds })
        dispatch({ type: 'SET_FORMS_V2_STATES', data: states?.formV2States })
        const { data: entryStats } = await api.post('/form_v2s/requests/count-entries', {
          'form_v2_ids': formIds
        })
        dispatch({ type: 'SET_FORMS_V2_ENTRY_COUNTS', data: entryStats?.formEntryCounts })
      }
    } catch (error) {
      dispatch(apiError('form-list', true))
    } finally {
      dispatch({ type: 'SET_FORMS_V2_LOADING', data: false })
      dispatch({ type: 'DELAY_V2_FORMS_LOAD', data: false })
    }
  }
}

export const updateFormAlias = (formId, options) => {
  return async dispatch => {
    const { alias, language } = options || {}

    try {
      dispatch({ type: 'SET_API_ERROR', data: { alias: null }})
      dispatch({ type: 'SET_ALIAS_LOADING', data: true })
      await api.put(`/form_v2s/${formId}/alias`, { alias })
      dispatch({ type: 'SET_FORM_V2_ALIAS', data: {
        formId,
        formAlias: alias || '',
      }})
    } catch (error) {
      if (error?.response?.data?.errors[0].issue_code === NOT_UNIQUE_FORM_ALIAS) {
        const conflictingFormId = error?.response?.data?.errors[0].form_v2_id
        try {
          const { data } = await api.get(`/form_v2s/${conflictingFormId}`)
          const formName = getTranslatedProperty(data, 'name', language)
          const formTitle = getPlainTextFromMarkup(getTranslatedProperty(data, 'title', language))
          dispatch({ type: 'SET_API_ERROR', data: { alias: {
            errorName: API_ERRORS.ALIAS.ALIAS_IN_USE,
            errorProps: {
              formName: formName || formTitle
            }
          }}})
        } catch (e) {
          dispatch({ type: 'SET_API_ERROR', data: {
            alias: {
              errorName: API_ERRORS.ALIAS.ALIAS_ERROR
            }
          }})
        }
      } else {
        dispatch({ type: 'SET_API_ERROR', data: {
          alias: {
            errorName: API_ERRORS.ALIAS.ALIAS_ERROR
          }
        }})
      }
    } finally {
      dispatch({ type: 'SET_ALIAS_LOADING', data: false })
    }
  }
}

export const duplicateForm = (form, options={}) => {
  const { language, copyText, errorMessage, successMessage } = options
  return async (dispatch) => {
    try {
      dispatch({ type: 'SET_FORMS_V2_LOADING', data: true })
      await api.post('/form_v2s/requests/duplicate', getDuplicateFormPayload(form, language, copyText))

      dispatch( { type: 'SHOW_TOAST', data: {
        type: 'success',
        title: successMessage
      }})
    } catch (error) {
      dispatch({ type: 'SHOW_TOAST', data: {
        type: 'error',
        title: errorMessage
      }})
    }
    finally {
      dispatch(fetchForms())
    }
  }
}
